import React from "react"
import Badge from "@react/shared/ui/Badge"

// Tier-coloured margin %. Tones map directly to Badge's soft variants.
const tierTone = pct => {
  if (pct == null || isNaN(pct)) return "slate"
  if (pct >= 40) return "emerald"
  if (pct >= 25) return "lime"
  if (pct >= 10) return "amber"
  if (pct <  0)  return "rose"
  return "orange"
}

const MarginBadge = ({ pct }) => {
  if (pct == null || isNaN(pct)) {
    return <span className="text-slate-400 text-sm">—</span>
  }
  return (
    <Badge tone={tierTone(pct)} variant="soft" size="sm" className="tabular-nums">
      {Math.round(pct)}%
    </Badge>
  )
}

export default MarginBadge
